<main>
  <p-toast position="bottom-right" key="br" />
  <loading-overlay [isLoading]="isLoading() > 0"></loading-overlay>

  <div class="content">
    <div class="page__title">
      <div class="page__title_container">
        <h1>{{ 'InventorySession_Title' | translateWF: 'Inventory Sessions' }}</h1>
        @if (canCreate()) {
          <div class="page__title_buttons">
            <p-button (click)="redirectToDetail()" [label]="'Common_Add' | translateWF: 'New Session'" icon="pi pi-plus" iconPos="left" />
          </div>
        }
      </div>
    </div>

    <div class="cs-page-list-grid">
      <!-- Filters Panel -->
      @if (filterConfig() && showFilters()) {
        <csl-dynamic-filters [filterConfig]="filterConfig()!" [state]="filterState" />
      }

      <!-- Data Table -->
      <p-panel header="Sessions">
        <ng-template pTemplate="icons">
          <p-button
            [label]="(showFilters() ? 'Common_Hide_Filters' : 'Common_Show_Filters') | translateWF: (showFilters() ? 'Hide Filters' : 'Show Filters')"
            [icon]="showFilters() ? 'pi pi-filter-slash' : 'pi pi-filter'"
            (click)="showFilters.set(!showFilters())"
            variant="outlined"
            size="small"
          />
        </ng-template>
        <p-card data-variant="compact">
          <p-table [value]="sessions()" selectionMode="single" [rowHover]="true">
            <ng-template pTemplate="header">
              <tr>
                <th>{{ 'InventorySession_Number' | translateWF: 'Number' }}</th>
                <th>{{ 'InventorySession_Name' | translateWF: 'Name' }}</th>
                <th>{{ 'InventorySession_Location' | translateWF: 'Location' }}</th>
                <th>{{ 'InventorySession_Status' | translateWF: 'Status' }}</th>
                <th>{{ 'InventorySession_Children' | translateWF: 'Children' }}</th>
                <th>{{ 'InventorySession_TotalScanned' | translateWF: 'Total Scanned' }}</th>
                <th>{{ 'InventorySession_CreatedBy' | translateWF: 'Created By' }}</th>
                <th>{{ 'Common_Created_Date' | translateWF: 'Created' }}</th>
              </tr>
            </ng-template>

            <ng-template pTemplate="body" let-session>
              @let s = sessionStrict(session);
              <tr class="cursor-pointer" (click)="redirectToDetail(s.id)">
                <td>
                  <a class="font-semibold text-primary">{{ s.number }}</a>
                </td>
                <td>{{ s.name || '-' }}</td>
                <td>{{ s.location?.name | localized }}</td>
                <td>
                  <p-tag [value]="getStatusLabel(s.status)" [severity]="getStatusSeverity(s.status)" />
                </td>
                <td>{{ s.children?.length || 0 }}</td>
                <td>{{ s.totalChildScannedCount }}</td>
                <td>{{ s.createdByUserName || '-' }}</td>
                <td>{{ formatDate(s.createdAt) }}</td>
              </tr>
            </ng-template>

            <ng-template pTemplate="emptymessage">
              <tr>
                <td colspan="8" class="text-center py-8">
                  {{ 'InventorySession_Not_Found' | translateWF: 'No inventory sessions found' }}
                </td>
              </tr>
            </ng-template>
          </p-table>

          <p-paginator
            [rows]="pageSize"
            [totalRecords]="totalRecords"
            [first]="(currentPage - 1) * pageSize"
            (onPageChange)="onPageChange($event)"
            [rowsPerPageOptions]="[10, 25, 50, 100]"
          ></p-paginator>
        </p-card>
      </p-panel>
    </div>
  </div>
</main>
